import React, { useEffect, useState } from "react";

import "./Laboratory.css";

import BtnAdd from "../Commons/Buttons/BtnAdd";
import AntDTable from "../AntDTable/AntDTable";
import SelectField from "../Commons/Forms/SelectField";
import DeleteModal from "../Modals/DeleteModal";

// import { Row, Col } from "react-bootstrap";
import { Card, Button as AntButton, Input } from "antd";
import { useParams } from "react-router-dom";
import {
  deleteLabResult,
  getLabTests,
  getAllLabResults,
  getLabResults,
  // getLabTestResult,
} from "../Helpers/API/LabApi/LaboratoryApi";
import {
  capitalizeFirstLetter,
  formatDate,
  formatLabel,
  getPatientBranchId,
  setPatientBranchId,
} from "../Helpers/Utilities/Common";
import { getLaboratoryResult } from "../Helpers/API/LabApi/LaboratoryResultApi";
import { examData } from "../Helpers/Constants/ExamData";
import { toast } from "react-toastify";
import { SeeAttachment } from "../Radiology/SeeAttachment";
import { RefreshRounded } from "@mui/icons-material";
import { Col, Row, Modal } from "react-bootstrap";
import BtnSave from "../Commons/Buttons/BtnSave";

function LaboratoryResults(props) {
  const { id } = useParams();
  const [searchLabTest, setSearchLabTest] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [laboratories, setLaboratories] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [transactionTests, setTransactionTests] = useState([]);
  const [transactionTestsLoading, setTransactionTestsLoading] = useState(false);
  const [autoOpened, setAutoOpened] = useState(false);

  // Function to delete lab result API
  const handleDelete = async () => {
    const res = await deleteLabResult(selectedRow.id);
    if (res.data) {
      toast.success(res.data.message);
      setSelectedRow({});
      setShowDelete(false);
      fetchData();
    } else if (res.error) {
      res.error.data.messages.error_messages.forEach((err) => {
        toast.error(err);
      });
    }
  };

  // Function show lab form
  function handleShowLabForm() {
    props.setShowCheckupTabs(false);
    props.showLabForm(true);
    props.showEvalForm(false);
  }

  // Function show evaluation form
  function handleShowEvalForm(data) {
    props.setAddEvaluation(data);
    props.setShowCheckupTabs(false);
    props.showLabForm(false);
    props.showEvalForm(true);
  }

  const normalizeStatus = (status) =>
    (status || "").toString().trim().toLowerCase();

  const isCompletedForEvaluation = (status) => {
    const value = normalizeStatus(status);

    // Treat these statuses as ready for evaluation
    return (
      value === "finalized" ||
      value === "waive" ||
      value === "waived" ||
      value === "for_evaluation" ||
      value === "for evaluation"
    );
  };

  const getTransactionStatus = (tests = []) => {
    if (!tests.length) {
      return "";
    }

    const normalizedStatuses = tests.map((test) =>
      normalizeStatus(test?.status)
    );

    const allEvaluated = normalizedStatuses.every(
      (status) => status === "evaluated"
    );

    if (allEvaluated) {
      return "Evaluated";
    }

    const readyForEvaluationStatuses = [
      "finalized",
      "waive",
      "waived",
      "for_evaluation",
      "for evaluation",
    ];

    const allCompletedForEval = normalizedStatuses.every((status) =>
      readyForEvaluationStatuses.includes(status)
    );

    if (allCompletedForEval) {
      return "For Evaluation";
    }

    return "Pending";
  };

  const openEvaluationForTransaction = async (transaction, fallbackCandidate) => {
    if (!transaction) {
      return;
    }

    const baseTests = transaction.tests || [];

    const transactionId =
      transaction.transaction_id ||
      transaction.transactionKey ||
      transaction.transactionNo;

    let detailedTests = baseTests;

    // if (transactionId) {
    //   try {
    //     const res = await getLabTestResult({
    //       transaction_id: transactionId,
    //       patient_id: props.patientId || id,
    //       branch_id: transaction.branch_id || getPatientBranchId() || "",
    //       table_name: "booking",
    //     });

    //     if (res?.data?.data) {
    //       detailedTests = res.data.data.map((lab) => {
    //         const normalizedAttachments = Array.isArray(lab.lab_result_attachments)
    //           ? lab.lab_result_attachments
    //           : lab.file_url
    //           ? [
    //               {
    //                 file_url: lab.file_url,
    //                 file_name: lab.file_name || "Attachment",
    //               },
    //             ]
    //           : [];

    //         return {
    //           ...lab,
    //           lab_result_attachments: normalizedAttachments,
    //           formatted_lab_name:
    //             lab.lab_name !== "laboratory" && lab.lab_name !== "others"
    //               ? formatLabel(lab.lab_test_sub_type).toUpperCase()
    //               : formatLabel(lab.lab_name).toUpperCase(),
    //           formattedStatus: (lab.status || "").toString().toUpperCase(),
    //           formattedResultDate: formatDate(lab.result_date),
    //         };
    //       });
    //     }
    //   } catch (error) {
    //     detailedTests = baseTests;
    //   }
    // }

    const evaluationCandidate =
      detailedTests.find((test) => isCompletedForEvaluation(test?.status)) ||
      fallbackCandidate;

    if (!evaluationCandidate) {
      return;
    }

    // Save branch_id from transaction for evaluation
    if (transaction.branch_id) {
      setPatientBranchId(transaction.branch_id);
    }

    handleShowEvalForm({
      ...evaluationCandidate,
      source_id: transaction.transaction_id || transactionId,
      table_name: "booking",
      is_force_evaluation: false,
      _transaction: transaction,
      _transaction_id: transactionId,
      _transaction_no:
        transaction?.transactionNo || transaction?.transactionKey || transactionId,
      _transaction_tests: detailedTests,
    });
  };

  const openForceEvaluationForTransaction = async (transaction) => {
    if (!transaction) {
      return;
    }
    const baseTests = transaction.tests || [];
    const transactionId =
      transaction.transaction_id ||
      transaction.transactionKey ||
      transaction.transactionNo;
    let detailedTests = baseTests;
    // if (transactionId) {
    //   try {
    //     const res = await getLabTestResult({
    //       transaction_id: transactionId,
    //       patient_id: props.patientId || id,
    //       branch_id: transaction.branch_id || getPatientBranchId() || "",
    //       table_name: "booking",
    //     });
    //     if (res?.data?.data) {
    //       detailedTests = res.data.data.map((lab) => {
    //         const normalizedAttachments = Array.isArray(lab.lab_result_attachments)
    //           ? lab.lab_result_attachments
    //           : lab.file_url
    //           ? [
    //               {
    //                 file_url: lab.file_url,
    //                 file_name: lab.file_name || "Attachment",
    //               },
    //             ]
    //           : [];

    //         return {
    //           ...lab,
    //           lab_result_attachments: normalizedAttachments,
    //           formatted_lab_name:
    //             lab.lab_name !== "laboratory" && lab.lab_name !== "others"
    //               ? formatLabel(lab.lab_test_sub_type).toUpperCase()
    //               : formatLabel(lab.lab_name).toUpperCase(),
    //           formattedStatus: (lab.status || "").toString().toUpperCase(),
    //           formattedResultDate: formatDate(lab.result_date),
    //         };
    //       });
    //     }
    //   } catch (error) {
    //     detailedTests = baseTests;
    //   }
    // }
    const fallbackCandidate = baseTests[0] || (detailedTests && detailedTests[0]) || null;
    if (!fallbackCandidate) {
      return;
    }
    
    // Save branch_id from transaction for evaluation
    if (transaction.branch_id) {
      setPatientBranchId(transaction.branch_id);
    }
    
    handleShowEvalForm({
      ...fallbackCandidate,
      source_id: transaction.transaction_id || transactionId,
      table_name: "booking",
      is_force_evaluation: true,
      _transaction: transaction,
      _transaction_id: transactionId,
      _transaction_no:
        transaction?.transactionNo || transaction?.transactionKey || transactionId,
      _transaction_tests: detailedTests,
    });
  };

  function ActionBtn(row) {
    const transaction = row?.row;

    return (
      <BtnSave
        id={"view-btn"}
        label={"View"}
        size={"sm"}
        onClick={(e) => {
          e.stopPropagation();
          handleTransactionRowClick(transaction);
        }}
      />
    );
  }

  // Function get Laboratory Results
  async function fetchData() {
    setShowLoader(true);
    const response = await getLabResults({
      patient_id: props.patientId || id,
      branch_id: getPatientBranchId() || "",
    });

    if (response?.data?.data) {
      let records = response.data.data;
      
      // Save branch_id from the first record to localStorage for evaluation
      if (records.length > 0 && records[0].branch_id) {
        setPatientBranchId(records[0].branch_id);
      }

      // Apply client-side search filter (still based on individual tests)
      if (searchLabTest) {
        const query = searchLabTest.toLowerCase();
        records = records.filter((lab) => {
          const fieldsToSearch = [
            lab.lab_name,
            lab.lab_test_name,
            lab.result,
            lab.status,
            ...(Array.isArray(lab.breakdowns)
              ? lab.breakdowns.flatMap((breakdown) => [
                  breakdown.analyte,
                  breakdown.result,
                ])
              : []),
          ];

          return fieldsToSearch.some((val) =>
            (val || "").toString().toLowerCase().includes(query)
          );
        });
      }

      // Normalize each test record
      const parsedTests = records.map((lab) => {
        const resultAttachments =
          lab.lab_result_attachments ?? lab.attachments;
        const normalizedAttachments = Array.isArray(resultAttachments)
          ? resultAttachments
          : lab.file_url
          ? [
              {
                file_url: lab.file_url,
                file_name: lab.file_name || "Attachment",
              },
            ]
          : [];

        return {
          ...lab,
          lab_result_attachments: normalizedAttachments,
          formatted_lab_name:
            typeof lab.lab_name === "string" &&
            !["laboratory", "others"].includes(lab.lab_name.toLowerCase())
              ? formatLabel(lab.lab_name).toUpperCase()
              : formatLabel(lab.lab_test_sub_type || lab.lab_name).toUpperCase(),
          formattedStatus: (lab.status || "").toString().toUpperCase(),
          attachment: <SeeAttachment attachments={normalizedAttachments} />,
          formattedResultDate: formatDate(lab.result_date),
        };
      });

      // Group tests per transaction
      const transactionsMap = parsedTests.reduce((acc, test) => {
        const transactionKey =
          test.transaction_no ||
          test.transaction_id ||
          test.source_id ||
          test.assessment_id ||
          test.id;

        const transactionNo = test.transaction_no || transactionKey;
        const transactionDateRaw = test.transaction_date || test.result_date;
        const transactionDateFormatted = transactionDateRaw
          ? formatDate(transactionDateRaw)
          : test.formattedResultDate;

        if (!acc[transactionKey]) {
          acc[transactionKey] = {
            key: transactionKey,
            transactionKey,
            transactionNo,
            formattedTransactionDate: transactionDateFormatted,
            transaction_id:
              test.transaction_id ||
              test.source_id ||
              test.assessment_id ||
              test.id,
            branch_id: test.branch_id,
            tests: [],
          };
        }

        acc[transactionKey].tests.push(test);

        return acc;
      }, {});

      const testRows = parsedTests.map((test, index) => {
        const transactionKey =
          test.transaction_no ||
          test.transaction_id ||
          test.source_id ||
          test.assessment_id ||
          test.id;
        const transaction = transactionsMap[transactionKey];

        return {
          ...test,
          key: `${transactionKey}-${test.id || index}`,
          transactionNo: transaction?.transactionNo,
          transactionKey: transaction?.transactionKey,
          transaction_id: transaction?.transaction_id,
          formattedTransactionDate: transaction?.formattedTransactionDate,
          tests: transaction?.tests || [test],
          status: getTransactionStatus(transaction?.tests || [test]),
          findings: test.findings ?? test.result ?? "",
        };
      });
      setTableData(testRows);
    } else {
      setTableData([]);
    }

    setShowLoader(false);
  }

  const columns = [
    {
      title: "Lab Date",
      dataIndex: "formattedResultDate",
      key: "formattedResultDate",
    },
    {
      title: "Lab",
      dataIndex: "formatted_lab_name",
      key: "formatted_lab_name",
    },
    {
      title: "Test",
      dataIndex: "lab_test_name",
      key: "lab_test_name",
    },
    {
      title: "Result",
      dataIndex: "result",
      key: "result",
    },
    {
      title: "Attachment",
      dataIndex: "attachment",
      key: "attachment",
    },
  ];

  const modalColumns = [
    {
      title: "Date",
      dataIndex: "result_date",
      key: "result_date",
      render: (value) => formatDate(value, value),
    },
    {
      title: "Analyte",
      dataIndex: "analyte",
      key: "analyte",
    },
    {
      title: "Result",
      dataIndex: "result",
      key: "result",
    },
  ];

  const getTransactionDetailGroups = (tests = []) =>
    tests.map((test, testIndex) => {
      const breakdowns = Array.isArray(test.breakdowns) ? test.breakdowns : [];
      const exam = examData.find(
        (item) =>
          item.cisExamName.toLowerCase() ===
          (test.lab_name || test.lab_test_name || "").toLowerCase()
      );

      if (breakdowns.length) {
        const rows = breakdowns.map((breakdown, breakdownIndex) => {
          const analyte = exam?.items.find(
            (item) => item.key === breakdown.analyte
          );
          const analyteName = analyte
            ? `${analyte.name}${analyte.unit ? ` (${analyte.unit})` : ""}`
            : formatLabel(breakdown.analyte);

          return {
            key: `${test.id || testIndex}-${breakdown.id || breakdownIndex}`,
            result_date: formatDate(breakdown.result_date || test.result_date),
            analyte: analyteName,
            result: breakdown.result || "",
          };
        });

        return {
          key: test.id || testIndex,
          labName: test.lab_test_name || test.lab_name || "Lab Result",
          date: formatDate(test.result_date),
          rows,
        };
      }

      return {
        key: test.id || testIndex,
        labName: test.lab_test_name || test.lab_name || "Lab Result",
        date: formatDate(test.result_date),
        rows: [
          {
            key: test.id || testIndex,
            result_date: formatDate(test.result_date),
            analyte:
              test.analyte ||
              test.lab_test_name ||
              formatLabel(test.lab_test_type || test.lab_name),
            result: test.findings ?? test.result ?? "",
          },
        ],
      };
    });

  function handleLabTestChange(e) {
    setSearchLabTest(e);
  }

  const handleEmptySearch = (e) => {
    if (e.target.value === "") {
      setSearchLabTest("");
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchLabTest, props.refreshKey]);

  useEffect(() => {
    if (props.autoOpenEvaluation && !autoOpened && tableData && tableData.length) {
      const transaction = tableData[0];
      const status = transaction?.status || "";
      const tests = transaction?.tests || [];
      const evaluationCandidate = tests.find((t) => isCompletedForEvaluation(t?.status));
      if (status === "For Evaluation" && evaluationCandidate) {
        openEvaluationForTransaction(transaction, evaluationCandidate);
        setAutoOpened(true);
      } else if (status === "Pending") {
        openForceEvaluationForTransaction(transaction);
        setAutoOpened(true);
      } else if (evaluationCandidate) {
        openEvaluationForTransaction(transaction, evaluationCandidate);
        setAutoOpened(true);
      }
    }
  }, [props.autoOpenEvaluation, tableData, autoOpened]);

  const handleTransactionRowClick = (record) => {
    setSelectedTransaction(record);
    setTransactionTests(getTransactionDetailGroups([record]));
    setTransactionTestsLoading(false);
    setShowTransactionModal(true);
  };

  return (
    <div>
      <Card className="card-with-table" style={{ minHeight: "500px" }}>
        <div>
          <div className="col pt-1 mb-4">
            <div className="row">
              <div className="col" style={{ display: "flex" }}>
                <h5 className="font-bold">LABORATORY RESULT</h5>
                <AntButton
                  type="text"
                  className="px-2"
                  onClick={fetchData}
                  icon={<RefreshRounded />}
                />
              </div>
              <div className="col-3">
                <BtnAdd
                  label={"+ Add Record"}
                  size={"md"}
                  onClick={(e) => handleShowLabForm()}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-4 pt-1 mb-2 d-flex justify-content-start">
              <Input.Search
                placeholder="Search Lab/Test"
                allowClear
                size="medium"
                onSearch={(e) => handleLabTestChange(e)}
                onChange={(e) => handleEmptySearch(e)}
              />
            </div>
          </div>
          <div className="lab-result-table">
            <AntDTable
              columns={columns}
              tableData={tableData}
              loading={showLoader}
              scroll={{ x: true }}
              isClickable={false}
              ActionBtn={(row) => ActionBtn(row)}
              actionBtnClassName="therapeautics-prescription-button"
              withAction={true}
              searchExcluded={["transactionNo", "formattedTransactionDate"]}
            />
          </div>
        </div>
      </Card>
      <Modal
        show={showTransactionModal}
        onHide={() => setShowTransactionModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Transaction Details
            {selectedTransaction?.transactionNo && (
              <span className="ms-2">
                ({selectedTransaction.transactionNo})
              </span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedTransaction && (
            <div>
              {transactionTestsLoading ? (
                <AntDTable
                  columns={modalColumns}
                  tableData={[]}
                  loading={true}
                  scroll={{ x: true }}
                  isClickable={false}
                  withAction={false}
                />
              ) : (
                transactionTests.map((group) => (
                  <div className="lab-result-table mb-3" key={group.key}>
                    <h6 className="font-bold">
                      {group.labName}
                      {group.date ? ` - ${group.date}` : ""}
                    </h6>
                    <AntDTable
                      columns={modalColumns}
                      tableData={group.rows}
                      loading={false}
                      scroll={{ x: true }}
                      isClickable={false}
                      withAction={false}
                      searchExcluded={["result_date"]}
                    />
                  </div>
                ))
              )}
            </div>
          )}
        </Modal.Body>
      </Modal>
      {/* DELETE */}
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onDelete={handleDelete}
        title={`Are you sure you want to delete this result?`}
      />
    </div>
  );
}

export default LaboratoryResults;
